(() => {
  'use strict';
  if (window.rogProcessUniversal) { window.rogProcessUniversal(document); return; }
  function init(scope) {
    scope.querySelectorAll('[data-rog-process]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      // All content is visible without scripts. Only the decorative line work enters.
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-arriving');
          observer.unobserve(entry.target);
        });
      }, {threshold:.12});
      root.querySelectorAll('.rog-process__step').forEach(step => observer.observe(step));
      const unload = event => {
        if (!event.target.contains(root)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  window.rogProcessUniversal = init;
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
